<template>
  <!-- <div class="video-header video_menu-on" style="background-color: white;">
  <div class="page_title-area video-header_inner video-header_padding">
    <button class="video_btn-camera" type="button">
      <img :src="require('../assets/img/video/video_icon-camera.png')" alt="カメラ切り替え">
    </button>
    <p class="page-title call-name">神山町役場</p>
    <div class="video_btn-call-end" @click="hangup">通話終了</div>
  </div>
</div> -->
  <div>
    <NavBar
      :title="remoteuser != null && remoteuser[4] != '' ? remoteuser[4] : ''"
      :fixed="true"
      :placeholder="true"
      safe-area-inset-top
    >
      <template #right>
        <div v-show="showHangup" class="video_btn-call-end" @click="hangup">通話終了</div>
      </template>
      <template #left>
        <img v-show="leftCamera"
          src="../assets/img/video/video_icon-camera.png"
          style="width: 30px"
          alt=""
          @click="changeCamera"
        />
      </template>
    </NavBar>
  </div>
</template>

<script>
import { NavBar } from 'vant';
export default {
  name: "VideoHeader",
  props: {
    msg: String,
    remoteuser: Array,
    showHangup: Boolean,
    leftCamera: Boolean
  },
  data() {
    return {
      title: "",
    };
  },
  components: {
    NavBar
  },
  created() {
  },
  mounted() {
    this.$forceUpdate();
  },
  methods: {
    changeCamera(){
      this.$emit('changeCamera');
    },
    hangup() {
      this.$emit("hangup");
    },
  },
};
</script>

<style scoped>
</style>